import src from "IMAGE";
export default { src, width: 216, height: 293, blurWidth: 0, blurHeight: 0};
